import { useState } from "react";
import { pageTitle } from "../PageTitle";
import HeaderOne from "../Header/HeaderOne";
import FooterOne from "../Footer/FooterOne";
import AiInvoiceBanner from "./../../assets/images/banner/go.png";
import Architecture from "./../../assets/images/banner/Architecture.png";
// import Brochures from "./../../assets/images/WA_fds.png";
import { Link } from "react-router-dom";

const resultsData = [
  {
    metric: "Order response time",
    before: "Manual replies",
    after: "Instant WhatsApp response",
  },
  {
    metric: "Orders handled",
    before: "Limited by staff availability",
    after: "More orders handled automatically",
  },
  {
    metric: "Missed grocery orders",
    before: "Frequent during busy hours",
    after: "Reduced significantly",
  },
  {
    metric: "Order accuracy",
    before: "Manual entry mistakes",
    after: "Improved item and quantity accuracy",
  },
  {
    metric: "Processing time",
    before: "Slow manual coordination",
    after: "Faster order processing",
  },
  {
    metric: "Staff time saved monthly",
    before: "High manual effort",
    after: "60+ hours saved",
  },
];

const featureCards = [
  {
    icon: "bi bi-cart-check-fill",
    title: "WhatsApp Grocery Ordering",
    desc: "Customers can order groceries directly through WhatsApp using item names, quantities, and simple messages.",
  },
  {
    icon: "bi bi-basket-fill",
    title: "Product & Quantity Detection",
    desc: "The AI understands grocery items, pack sizes, quantities, and common customer ordering patterns.",
  },
  {
    icon: "bi bi-image-fill",
    title: "Image-Based Order Support",
    desc: "Customers can share grocery lists, product photos, or screenshots, and the system helps capture order details.",
  },
  {
    icon: "bi bi-translate",
    title: "Multilingual Grocery Support",
    desc: "Supports English, Tamil, Malay, Mandarin, and mixed-language conversations for real customer ordering.",
  },
  {
    icon: "bi bi-check2-circle",
    title: "Order Confirmation",
    desc: "Automatically confirms grocery orders, reduces incomplete orders, and helps customers verify items before processing.",
  },
  {
    icon: "bi bi-shop",
    title: "Built for Grocery Stores",
    desc: "Suitable for supermarkets, mini-marts, provision shops, online grocery sellers, and delivery-based grocery businesses.",
  },
];

const faqs = [
  {
    q: "How is this different from normal online grocery ordering?",
    a: "Traditional online ordering usually requires customers to open a website or app and search manually. Our WhatsApp Grocery Ordering allows customers to place orders naturally through WhatsApp using text, images, or mixed-language messages.",
  },
  {
    q: "Do customers need to install a separate app?",
    a: "No. Customers can use WhatsApp directly to place grocery orders, making it easier for regular customers, elderly customers, and repeat buyers.",
  },
  {
    q: "Can the AI understand grocery item names and quantities?",
    a: "Yes. The AI can understand product names, quantities, pack sizes, and common grocery ordering formats based on your actual product list and business flow.",
  },

  {
    q: "Can it reduce manual order-taking effort?",
    a: "Yes. It helps automate order capture, confirmation, and follow-up, reducing staff workload and improving order handling during busy hours.",
  },
  {
    q: "Who is this solution suitable for?",
    a: "It is suitable for grocery stores, supermarkets, mini-marts, provision shops, delivery-based grocery businesses, and stores receiving orders through WhatsApp.",
  },
];

const Wa_Grocery_Ord = () => {
  pageTitle("WhatsApp Grocery Ordering");

  const [openIndex, setOpenIndex] = useState(0);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? -1 : index);
  };
  const handleWhatsAppClick = () => {
    const phoneNumber = "6590059743"; // WhatsApp number (no '+' or spaces)
    const message = "Hello! I would like to know more about your services.";
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(url, "_blank");
  };

  return (
    <>
      <HeaderOne />

      <div
        className="ai-overlay-wrapper-solutions"
        style={{ backgroundImage: `url(${AiInvoiceBanner})` }}
      >
        <div className="ai-overlay">
          <div className="ai-overlay-center-project-text-solutions">
            <h2 className="ai-overlay-project">
              AI-Powered <br /> WhatsApp Grocery Ordering
            </h2>
          </div>
          <div className="siw-hero-price-box-sol">
            <h3>From SGD 100/month</h3>

            <button
              onClick={handleWhatsAppClick}
              className="theme-btn theme-btn-one siw-hero-small-btn"
            >
              Start a Free Trial
            </button>
          </div>
        </div>
      </div>

      <section className="py-3 py-md-4">
        <div className="container">
          {/* <h3 className="siw-project-heading">
            One WhatsApp message is all it takes, automate your grocery orders instantly.
          </h3> */}

          <div className="row g-4 align-items-stretch">
            <div className="col-lg-7 d-flex">
              <div className="food-grey-box w-100">
                <h3 className="siw-project-heading pb-1">
                  Built for real-time grocery ordering conversations
                </h3>
                <p className="mb-0 siw-rpa-desc">
                  Most grocery ordering systems fail when customers order
                  naturally. People send short messages, product names, item
                  quantities, pack sizes, and shopping lists in different
                  formats. Some customers also share product photos or switch
                  languages while ordering. Our WhatsApp AI is built to
                  understand these real-world grocery ordering patterns.
                </p>
                <p className="siw-rpa-desc">
                  It works based on your actual grocery catalogue and business
                  flow. The system recognizes item names, aliases, quantities,
                  categories, and pricing. It can process text, image-based
                  orders, and customer follow-ups more smoothly. This helps
                  customers order faster while reducing manual work for your
                  store team.
                </p>
              </div>
            </div>

            <div className="col-lg-5 d-flex">
              <div className="siw-project-video-wrapper">
                <iframe
                  className="siw-project-video"
                  src="https://www.youtube.com/embed/wmpuRPpPTP4?si=rdtO9M1k_lEev4RL"
                  title="WhatsApp Grocery Ordering Video"
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                ></iframe>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="py-3  pt-md-0 pb-md-5 wafod-features-section">
        <div className="container">
          <h3 className="wafod-section-heading">Architecture</h3>
          <img
            src={Architecture}
            alt="Architecture"
            className="img-fluid mb-4"
            height="200"
          />
          <div className="mb-5">
            <h3 className="wafod-section-heading">Key Features</h3>
          </div>

          <div className="row g-4">
            {featureCards.map((item, index) => (
              <div className="col-md-6 col-lg-4" key={index}>
                <div className="food-feature-card wafod-feature-card h-100">
                  <div className="food-feature-icon wafod-feature-icon">
                    <i className={item.icon}></i>
                  </div>
                  <h5 className="wafod-card-title">{item.title}</h5>
                  <p className="mb-0 wafod-card-text">{item.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-3 py-md-5 wafod-results-section">
        <div className="container">
          <div className="mb-4">
            <h3 className="wafod-section-heading-light pb-1">
              Business Impact
            </h3>
          </div>

          <div className="siw-subscription-table-wrap">
            <table className="siw-subscription-table">
              <thead>
                <tr>
                  <th>Metric</th>
                  <th>Before</th>
                  <th>After</th>
                </tr>
              </thead>

              <tbody>
                {resultsData.map((row, index) => (
                  <tr key={index}>
                    <td>{row.metric}</td>
                    <td>{row.before}</td>
                    <td>{row.after}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* <section className="py-3 py-md-4 wafod-industry-section">
        <div className="container text-center">
          <h3 className="wafod-section-heading-light">Industry Focus</h3>
          <div className="mt-4 d-inline-block px-4 py-3 shadow-sm rounded wafod-industry-card">
            <h5 className="mb-0 wafod-card-title wafod-section-heading-light">
              Grocery & Retail
            </h5>
          </div>
        </div>
      </section> */}

      <section className="pt-3 pb-2 py-md-4 wafod-faq-section">
        <div className="container">
          <div className=" mb-5">
            <h3 className="wafod-section-heading">Common Questions</h3>
          </div>

          <div className="accordion wafod-accordion">
            {faqs.map((item, index) => (
              <div
                className="accordion-item food-accordion-item wafod-accordion-item mb-3"
                key={index}
              >
                <h2 className="accordion-header wafod-accordion-header">
                  <button
                    type="button"
                    className={`accordion-button food-accordion-btn wafod-accordion-btn ${
                      openIndex !== index ? "collapsed" : ""
                    }`}
                    onClick={() => toggleAccordion(index)}
                    aria-expanded={openIndex === index}
                  >
                    {item.q}
                  </button>
                </h2>

                <div
                  className={`accordion-collapse collapse ${
                    openIndex === index ? "show" : ""
                  }`}
                >
                  <div className="accordion-body wafod-accordion-body">
                    {item.a}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* <section className="pt-0 pb-4 pb-md-5">
        <div className="container">
          <div className="mb-5">
            <h3 className="siw-project-heading">Download Brochure</h3>
          </div>

          <div className="row g-4 align-items-left">
            <div className="col-md-6 d-flex flex">
              <div className="food-grey-box w-100 d-flex flex-column ">
                <img
                  src={Brochures}
                  alt="Grocery Ordering Brochure"
                  className="food-brochure-preview img-fluid mx-auto my-2"
                  onClick={() => setShowBrochureModal(true)}
                />

                <a
                  href={Brochures}
                  download="WA_fds.png"
                  className="siw-rpa-btn mt-2 text-center w-50 mx-auto"
                >
                  Download Brochure
                </a>
              </div>
            </div>

            {showBrochureModal && (
              <div
                className="wafod-brochure-modal"
                onClick={() => setShowBrochureModal(false)}
              >
                <div
                  className="wafod-brochure-modal-content"
                  onClick={(e) => e.stopPropagation()}
                >
                  <button
                    type="button"
                    className="wafod-brochure-close"
                    onClick={() => setShowBrochureModal(false)}
                  >
                    &times;
                  </button>

                  <img
                    src={Brochures}
                    alt="Grocery Ordering Brochure Preview"
                    className="wafod-brochure-modal-img"
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </section> */}

      <FooterOne />
    </>
  );
};

export default Wa_Grocery_Ord;
